import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const ContainerS = styled.div`
  padding: 32px 48px 0;
  max-width: 1440px;

  @media ${(props) => props.theme.device.tabletL} {
    padding: 28px 22px 0;
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding: 24px 16px 0;
  }
`;

const Container = ({ children, className = '' }) => (
  <ContainerS className={`container-fluid ${className}`}>{children}</ContainerS>
);

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Container;
